import authService from '../services/authService';
import { API_ENDPOINTS } from '../config/api-endpoints';

const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';

const getHeaders = () => ({
  'Authorization': `Bearer ${authService.getToken()}`,
});

// Replaces: uploadFileToS3(file, folder)
export const uploadFile = async (file: File, folder = 'thumbnails') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  const response = await fetch(`${baseURL}${API_ENDPOINTS.UPLOAD_FILE}`, {
    method: 'POST',
    headers: getHeaders(),
    body: formData,
  });

  const result = await response.json();
  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to upload file');
  }
  return result; // { success, url, key }
};

// Replaces: listObjects(folderPath)
export const listObjects = async (folderPath = '') => {
  const params = new URLSearchParams({ path: folderPath });
  const response = await fetch(`${baseURL}${API_ENDPOINTS.LIST_FILES}?${params}`, {
    headers: getHeaders(),
  });

  const result = await response.json();
  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to list files');
  }
  return result.objects;
};

// Replaces: listAllFilesRecursively(folderPath)
export const listAllFilesRecursively = async (folderPath = '') => {
  const params = new URLSearchParams({ path: folderPath });
  const response = await fetch(`${baseURL}${API_ENDPOINTS.LIST_FILES_RECURSIVE}?${params}`, {
    headers: getHeaders(),
  });

  const result = await response.json();
  if (!response.ok || !result.success) {
    throw new Error(result.message || 'Failed to list files');
  }
  return result.files;
};

// Replaces: direct S3 URL fetch for individual file download

export const getFileBlob = async (key: string, signal?: AbortSignal) => {
  const params = new URLSearchParams({ key });
  const response = await fetch(`${baseURL}${API_ENDPOINTS.DOWNLOAD_FILE}?${params}`, {
    headers: getHeaders(),
    signal,
  });

  if (!response.ok) throw new Error('Failed to load file');

  return response.blob();
};

export const downloadFile = async (key: string, fileName?: string) => {
  const blob = await getFileBlob(key);
  const name = fileName || key.split('/').pop() || 'download';
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
};

// Replaces: client-side JSZip folder download
export const downloadFolder = async (path: string, folderName?: string) => {
  const params = new URLSearchParams({ path });
  const response = await fetch(`${baseURL}${API_ENDPOINTS.DOWNLOAD_FOLDER}?${params}`, {
    headers: getHeaders(),
  });

  if (!response.ok) throw new Error('Failed to download folder');

  const blob = await response.blob();
  const name = folderName || path.replace(/\/+$/, '').split('/').pop() || 'download';
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${name}.zip`;
  link.click();
  URL.revokeObjectURL(link.href);
};
